/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogColorGradient } from "../../d-dialog-color-gradient";
import { DThemeWhiteDialogFitted } from "./d-theme-white-dialog-fitted";

export class DThemeWhiteDialogColorGradient
	extends DThemeWhiteDialogFitted
	implements DThemeDialogColorGradient {}
